import React from "react";

import { useTranslation } from "react-i18next";

import DesktopLayout from "@components-shared/desktop/layout/DesktopLayout";
import { Button } from "@components/buttons";
import { retryWithLastVisitedUrl } from "@utils";

export function ConnectionLostPage(props: { full?: boolean }) {
	if (props.full) {
		return (
			<DesktopLayout>
				<section className="l--content l--content--full">
					<div className="l--content__main">
						<div className="container">
							<div className="card--primary card--shadowy card--message">
								<div className="card--message__thumb" />
								<div className="card--message__body">
									<div className="card--message__content">
										<Message />
										<div className="card--message__footer">
											<Button
												type="button"
												onClick={
													retryWithLastVisitedUrl
												}
												className="btn--base btn--block btn--accent btn--icon btn--animate-rotate"
												atClassName="ConnectionLostPage--full__btn--primary"
												btnContent={<BtnContent />}
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			</DesktopLayout>
		);
	}

	return (
		<div className="at-errorPage card--message u-mar--top--xsml">
			<div className="card--message__thumb" />
			<div className="card--message__body">
				<div className="card--message__content">
					<Message />
					<div className="card--message__footer">
						<Button
							type="button"
							onClick={retryWithLastVisitedUrl}
							atClassName="ConnectionLostPage__btn--primary"
							className="btn--base btn--block btn--accent btn--icon btn--animate-rotate"
							btnContent={<BtnContent />}
						/>
					</div>
				</div>
			</div>
		</div>
	);
}

function Message() {
	const t = useTranslation().t;
	return (
		<>
			<i className="card--message__icon u-icon u-icon--xlrg u-icon--alert-circle u-color--sent--danger u-icon--animated--bounce-in" />
			<div className="card--message__title">
				{t<string>("CONNECTION_LOST_PAGE.TITLE")}
			</div>
			<div className="u-type--center">
				{t<string>("CONNECTION_LOST_PAGE.MESSAGE")}
			</div>
		</>
	);
}

function BtnContent() {
	const t = useTranslation().t;

	return (
		<>
			<i className="u-icon u-icon--sml u-icon--refresh u-color--accent--text" />
			<span>{t<string>("COMMON.RETRY")}</span>
		</>
	);
}
